module.exports = __webpack_public_path__ + "static/img/bg-ar.1ee83b37.webp";